export default __webpack_public_path__ + "static/media/matplot.c0992e21.png";